import React from 'react';

import DateFilter from './DateFilter';
import UsersFilter from './UsersFilter';
import WorkspacesFilter from './WorkspacesFilter';
import CompletedFilter from './CompletedFilter/CompletedFilter';

import './index.scss';
import { WpIcon } from 'Wpds/components/icon';

type Props = {
  isOpen: boolean;
  onFilterOpenToggle: (event: React.MouseEvent<HTMLInputElement>) => void;
};

export default function SearchSideBar({ isOpen, onFilterOpenToggle }: Props) {
  return (
    <div className={`d-flex bg-light flex-column search-module-sidebar ${isOpen && 'search-module-sidebar--show'}`}>
      <div className="d-flex align-items-end justify-content-between w-100 px-3" style={{ height: '42px' }}>
        <p className="text-uppercase font-weight-bold mb-1" style={{ fontSize: '11px', lineHeight: '147%' }}>
          Filters:
        </p>
        <p className="mb-1 cursor-pointer" onClick={onFilterOpenToggle}>
          <WpIcon name="times" />
        </p>
      </div>
      <div className="px-3 search-module-sidebar-list h-100">
        <UsersFilter title="Assigned by" name="assignedBy" />
        <UsersFilter title="Assigned to" name="assignedTo" />
        <CompletedFilter />
        <WorkspacesFilter />
        <DateFilter />
      </div>
    </div>
  );
}
